var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-layout[data-v-b6b21680] {\n  background-image: url(" + escape(require("@/assets/images/wow_pattern_web.svg")) + ");\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-size: cover;\n}\n.ant-layout-header[data-v-b6b21680] {\n  background-image: url(" + escape(require("@/assets/images/neta_header_mask.png")) + ");\n  background-position: center center;\n  background-color: #003375;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n@media (max-width: 576px) {\n.ant-layout-header[data-v-b6b21680] {\n      padding: 0 10px;\n}\n}\n", ""]);

// exports
